import axios from 'axios';
export default {
	state: {
		dzoList: [],
	},
	getters: {
		dzoList(state) {
			return state.dzoList;
		},
	},
	mutations: {
		SET_DZO_LIST(state, payload) {
			state.dzoList = payload;
		},
	},
	actions: {
		getAllDzo({ commit }) {
			return axios.get('auth/kmg_dzo/').then(response => {
				let receivedDzo = response.data;
				let dzoList = receivedDzo
					.map(item => ({
						value: item.id,
						text: item.name,
					}))
					.filter(item => {
						return (
							item.text !== 'АО "ТЕСТОВЫЙ"' &&
							item.text !== 'АО НК Казмунайгаз' &&
							item.text !== 'АО Новое ДЗО'
						);
					});
					const allDzoOption = {value: 'all', text: 'Все ДЗО'}
					dzoList.push(allDzoOption)

				commit('SET_DZO_LIST', dzoList);
			});
		},
	},
};
